<template>
  <div
    ref="mainWrapper"
    v-tippy="{
      trigger: 'manual',
      theme: 'board-card',
      placement: 'right-start',
      content: tippyContent,
      boundary: tippyBoundary,
      maxWidth: 210,
      popperOptions: {
        modifiers: [
          {
            name: 'flip',
            options: {
              boundary: tippyBoundary,
              flipVariations: true,
            },
          },
        ],
      }
    }"
    :class="[
      $style.card,
      task.overdue ? $style.overdue : '',
    ]"
  >
    <div :class="$style.header">
      <div
        :class="$style.path"
        @mouseover.stop="toggleCardTip(true)"
        @mouseleave.stop="toggleCardTip(false)"
      >
        <span v-for="breadcrumb in task.breadcrumbs.shortened">
          {{ breadcrumb }}
        </span>
      </div>
      <div :class="[$style.name_and_color]">
        <div
          :class="[
            $style.color
          ]"
          :style="{
            backgroundColor: task.hexColor
          }"
        >
        </div>
        <div
          :class="[
            $style.name
          ]"
          @mouseover.stop="toggleCardTip(true)"
          @mouseleave.stop="toggleCardTip(false)"
        >
          {{ task.text }}
        </div>
      </div>
    </div>

    <div :class="$style.primary_info">
      <div
        :class="$style.left"
      >
        <div
          v-if="task.showStatus"
          :class="[
            $style.status
          ]"
        >
          <svg-sprite
            :name="task.statusOption.icon"
            type="bold"
            :size="16"
            :style="{ color: task.statusOption.color }"
          />
          <div :class="$style.status__label">
            {{ task.statusOption.value }}
          </div>
        </div>
        <div
          v-if="task.showPriority"
          :class="[
            $style.priority
          ]"
        >
          <svg-sprite
            :name="task.priorityOption.icon"
            type="bold"
            :size="16"
            :style="{ color: task.priorityOption.color }"
          />
          <div :class="$style.priority__label">
            {{ task.priorityOption.value }}
          </div>
        </div>
      </div>
      <div :class="$style.right">
        <assigned-select
          :class="[
            $style.resources,
          ]"
          :resources="task.resources"
          :max-visible="3"
          :readOnly="task.sharedView"
        />
      </div>
    </div>

    <div :class="$style.footer">
      <div
        :class="$style.dates"
      >
        <div :class="[$style.date]">
          {{ task.formattedStartDate }}
        </div>
        <div :class="$style.separator">
          -
        </div>
        <div :class="[$style.date]">
          {{ task.formattedEndDate }}
        </div>
      </div>
      <div
        :class="$style.status_bar"
      >
        <div
          v-if="task.hasComments"
          :class="[
            $style.comments,
            task.newComments ? $style.new : ''
          ]"
        >
          <svg-sprite
            name="comments"
            :size="20"
          />
        </div>
        <div
          v-if="task.hasAttachments"
          :class="[$style.attachments]"
        >
          <svg-sprite
            name="attach"
            :size="20"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AssignedSelect from './AssignedSelect.vue';

export default {
  name: 'SharedCard',
  components: {
    AssignedSelect
  },
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  inject: ['customHelper', 'getProjectName', 'tippyBoundary'],
  computed: {
    tippyContent() {
      return `
        <div class="task-name">${this.customHelper.formatTaskName(this.task.text)}</div>
        <div style="display: flex; align-items: center; width: 100%; padding: 0 4px; min-height: 24px;">
          <div style="background: #E5E5E5; min-height: 1px; flex-grow: 1;"></div>
        </div>
        <div>${__('board_path')}:<br>${this.task.breadcrumbs.all.join(' / ') || this.getProjectName()}</div>
      `;
    },
    tippyBoundary() {
      return document.querySelector('.board_container');
    }
  },
  methods: {
    toggleCardTip(flag) {
      const tippy = this.$refs.mainWrapper._tippy;

      if (this.tippyTimeout) {
        clearTimeout(this.tippyTimeout);
      }

      if (flag) {
        this.tippyTimeout = setTimeout(() => {
          tippy.show();
        }, 300);
      } else {
        this.tippyTimeout = setTimeout(() => {
          tippy.hide();
        }, 100);
      }
    }
  }
}

</script>

<style lang="less" module src="../less/sharedCard.less"></style>
